import { PepDetailsDto, PepDetailsModel } from '../types'

export const transformPepDetails = (pepDetails: PepDetailsDto): PepDetailsModel => ({
  type: pepDetails.type,
  associatedPepFullName: pepDetails.associated_pep_full_name,
  holdsPositionFrom: pepDetails.holds_position_from,
  organisation: pepDetails.organisation,
  position: pepDetails.position,
})
